var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Container, Header } from 'semantic-ui-react';
import { HistorizedQuery, RowsQuery } from '~/Api';
import * as ReportApi from '~/Api/Report';
import { useApi } from '~/ApiHooks';
import { useRequireAccessToken } from '~/Application/useRequireAccessToken';
import { ReportRoute } from '~/Application/routes';
import { useStore } from '~/Application/Store';
import { ErrorConsumer } from '~/ErrorHandler';
import { MessageType, useFlashMessage } from '~/FlashMessage';
import * as Impersonate from '~/Impersonate';
import { ExportButton, fromUserFormat, ReportSettings, validateFormat } from '~/Report';
import { ReportTable } from '~/ReportTable';
import { ColumnSettings } from '~/ReportTable/ColumnSettings';
import { useSearchParams } from '~/Router';
import { downloadFileFromUrl, ErrorAlert, Placeholder } from '~/UI';
import { Failure, Loading, Success } from '~/Result';
var DangerousEmbededHtml = function (_a) {
    var html = _a.html;
    var ref = React.useRef(null);
    React.useLayoutEffect(function () {
        var _a, _b;
        // tslint:disable-next-line: no-eval
        Array.from((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('script')) !== null && _b !== void 0 ? _b : []).forEach(function (script) {
            eval(script.innerHTML);
        });
    }, []);
    return <div dangerouslySetInnerHTML={{ __html: html }} ref={ref}/>;
};
export var Report = function (_a) {
    var id = _a.id;
    useRequireAccessToken();
    var _b = useStore(), reports = _b.reports, customReports = _b.customReports, reloadCustomReports = _b.reloadCustomReports;
    var _c = React.useState(null), updatedReport = _c[0], setUpdatedReport = _c[1];
    var pickReport = function () {
        var _a, _b, _c, _d;
        var originalReport = (_b = (_a = reports.value) === null || _a === void 0 ? void 0 : _a.items.find(function (report) { return report.id === id; })) !== null && _b !== void 0 ? _b : null;
        if (originalReport !== null) {
            return ReportApi.Report.createFromRawReport(originalReport);
        }
        var customReport = (_d = (_c = customReports.value) === null || _c === void 0 ? void 0 : _c.items.find(function (report) { return report.id === id; })) !== null && _d !== void 0 ? _d : null;
        if (customReport !== null) {
            var report_1 = __assign(__assign({}, customReport.reportInfo), { name: customReport.name, description: customReport.description, historized: customReport.historized, isCustom: true, source: customReport.source });
            return ReportApi.Report.createFromRawReport(report_1);
        }
        return null;
    };
    var report = React.useMemo(function () {
        if (updatedReport !== null && id === updatedReport.id) {
            return updatedReport;
        }
        return pickReport();
    }, [id, reports, customReports, updatedReport]);
    var isLoading = reports.isLoading || customReports.isLoading;
    return (<Container fluid>
			<ErrorConsumer>{function (error) { return <ErrorAlert>{error}</ErrorAlert>; }}</ErrorConsumer>
			{report !== null ? (<Content isLoading={isLoading} report={report} onChange={function (updatedReport) {
                setUpdatedReport(updatedReport);
            }} onCustomReportsReload={reloadCustomReports}/>) : isLoading ? (<Placeholder />) : (<p>Not found</p>)}
		</Container>);
};
Report.displayName = 'Application.Report';
var Content = function (_a) {
    var isLoading = _a.isLoading, report = _a.report, onChange = _a.onChange, onCustomReportsReload = _a.onCustomReportsReload;
    var _b = useFlashMessage(), setFlashMessage = _b[1];
    var redirect = ReportRoute.useRedirect();
    var searchParams = useSearchParams();
    var historizedQuery = new HistorizedQuery(searchParams.get('data-version-id'));
    var _c = React.useState(''), headerId = _c[0], setHeaderId = _c[1];
    var updatedReport = React.useMemo(function () { return ReportApi.Report.createCopy(report); }, [report]);
    var header = React.useMemo(function () {
        var header = updatedReport.headers.find(function (header) { return header.id === headerId; });
        if (header !== undefined) {
            return header;
        }
        return {
            dataType: ReportApi.DataType.text,
            id: '',
            sequenceNumber: 0,
            title: '',
        };
    }, [report, headerId]);
    var _d = useApi(), saveCustomizedReport = _d[0], savedCustomizedReportResult = _d[1];
    var _e = useApi(), createExport = _e[0], exportResult = _e[1];
    var exportDoc = function (format) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createExport(new ReportApi.ExportRequest(updatedReport.id, format, updatedReport.isCustom, updatedReport.reportSettings, historizedQuery))];
                case 1:
                    result = _a.sent();
                    if (result.value !== null) {
                        downloadFileFromUrl(result.value.export.downloadUrl);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var query = React.useMemo(function () {
        var _a, _b;
        return new RowsQuery(Number((_a = searchParams.get('page')) !== null && _a !== void 0 ? _a : 1), 18, (_b = (updatedReport.sort.length > 0 ? updatedReport.sort : updatedReport.defaultSort)) !== null && _b !== void 0 ? _b : [], searchParams.get('data-version-id'));
    }, [searchParams, updatedReport]);
    var updateQuery = function (query) {
        redirect({ id: updatedReport.id, page: query.page, sortFields: query.sortFields });
    };
    var _f = React.useState(0), customized = _f[0], setCustomized = _f[1];
    var _g = React.useState(false), unusedChanges = _g[0], setUnusedChanges = _g[1];
    var customize = function () {
        setCustomized(customized + 1);
        setUnusedChanges(false);
        setTimeout(function () {
            updatedReport.removeHiddenHeaders();
            onChange(updatedReport);
        });
    };
    var saveCustomReportChanges = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    customize();
                    return [4 /*yield*/, saveCustomizedReport(new ReportApi.UpdateCustomizedReportRequest(updatedReport.id, updatedReport))];
                case 1:
                    result = _a.sent();
                    return [4 /*yield*/, onCustomReportsReload()];
                case 2:
                    _a.sent();
                    if (result instanceof Success) {
                        setCustomized(0);
                        setFlashMessage({
                            text: 'Změny v reportu byly uloženy',
                            type: MessageType.success,
                        });
                        return [2 /*return*/];
                    }
                    if (result instanceof Failure) {
                        setFlashMessage({
                            text: 'Nebylo možné uložit report',
                            type: MessageType.error,
                        });
                        return [2 /*return*/];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var hideColumn = function (reportToEdit, header) {
        if (reportToEdit.referentialColumns.includes(header.id)) {
            setFlashMessage({
                subtext: 'Nelze skrýt referenční sloupec!',
                text: 'Chyba:',
                type: MessageType.error,
            });
            return reportToEdit;
        }
        if (reportToEdit.isHidden(header.id)) {
            setFlashMessage({
                subtext: 'Nelze znovu skrýt již skrytý sloupec!',
                text: 'Chyba:',
                type: MessageType.error,
            });
            return reportToEdit;
        }
        if (reportToEdit.getDefaultSort(header.id) !== null) {
            setFlashMessage({
                subtext: 'Nelze skrýt sloupec použitý pro řazení!',
                text: 'Chyba:',
                type: MessageType.error,
            });
            return reportToEdit;
        }
        if (reportToEdit.getSort(header.id) !== null) {
            setFlashMessage({
                subtext: 'Nelze skrýt sloupec použitý pro řazení!',
                text: 'Chyba:',
                type: MessageType.error,
            });
            return reportToEdit;
        }
        if (reportToEdit.isFiltered(header.id)) {
            setFlashMessage({
                subtext: "Nelze skr\u00FDt sloupec ".concat(header.title, ". Je podle n\u011Bj filtrov\u00E1no!"),
                text: 'Chyba:',
                type: MessageType.error,
            });
            return reportToEdit;
        }
        var nextReport = ReportApi.Report.createCopy(reportToEdit);
        if (nextReport.getSort(header.id) !== null) {
            nextReport.removeSort(header.id);
        }
        if (nextReport.getDefaultSort(header.id) !== null) {
            setFlashMessage({
                subtext: 'Nelze skrýt sloupec použitý pro řazení!',
                text: 'Chyba:',
                type: MessageType.error,
            });
            return reportToEdit;
        }
        nextReport.addHiddenColumn(header);
        return nextReport;
    };
    var sortColumn = function (reportToEdit, sort) {
        if (reportToEdit.isHidden(sort.property)) {
            setFlashMessage({
                subtext: 'Nelze řadit podle skrytého sloupec!',
                text: 'Chyba:',
                type: MessageType.error,
            });
            return reportToEdit;
        }
        var nextReport = ReportApi.Report.createCopy(reportToEdit);
        if (nextReport.isHidden(sort.property)) {
            nextReport.removeHiddenColumn(sort.property);
        }
        nextReport.addSort(sort);
        return nextReport;
    };
    var filterColumn = function (reportToEdit, header, data, comparison) {
        var value = fromUserFormat(header.dataType, data);
        var newFilterColumn = { columnName: header.id, dataType: header.dataType, value: value, comparison: comparison };
        if (validateFormat(header.dataType, value)) {
            setFlashMessage({
                subtext: 'Hodnota neodpovídá datovému typu používanému ve sloupci',
                text: 'Chyba:',
                type: MessageType.error,
            });
            return reportToEdit;
        }
        if (reportToEdit.isHidden(header.id)) {
            setFlashMessage({
                subtext: "Nelze filtrovat podle sloupce ".concat(header.title, ". Sloupec je nastaven jako skryt\u00FD!"),
                text: 'Chyba:',
                type: MessageType.error,
            });
            return reportToEdit;
        }
        var nextReport = ReportApi.Report.createCopy(reportToEdit);
        if (nextReport.isFilteredValue(header.id, value)) {
            nextReport.removeFilter(newFilterColumn);
        }
        else {
            nextReport.addFilter(newFilterColumn);
        }
        return nextReport;
    };
    var revealColumn = function (reportToEdit, header) {
        var nextReport = ReportApi.Report.createCopy(reportToEdit);
        nextReport.removeHiddenColumn(header.id);
        return nextReport;
    };
    var removeSort = function (reportToEdit, headerId) {
        var defaultSort = reportToEdit.defaultSort.find(function (sort) { return reportToEdit.isHidden(sort.property); });
        if (reportToEdit.getSort(headerId) !== null && reportToEdit.sort.length === 1 && defaultSort !== undefined) {
            setFlashMessage({
                subtext: 'Nelze odebrat řazení podle tohoto sloupce. Výchozí sloupec určený pro řazení je sktytý. Nejprve odeberte vychozí sloupec určený pro řazení ze skrytých sloupců nebo vyberte jiný sloupec pro řazení dat.',
                text: 'Chyba:',
                type: MessageType.error,
            });
            return reportToEdit;
        }
        var nextReport = ReportApi.Report.createCopy(reportToEdit);
        nextReport.removeSort(headerId);
        return nextReport;
    };
    var removeFilter = function (reportToEdit, filter) {
        var nextReport = ReportApi.Report.createCopy(reportToEdit);
        nextReport.removeFilter(filter);
        return nextReport;
    };
    var removeColumnFilters = function (reportToEdit, headerId) {
        var nextReport = ReportApi.Report.createCopy(reportToEdit);
        nextReport.removeAllFilters(headerId);
        return nextReport;
    };
    return (<div className='reports-header'>
			<Container className='headerContainder'>
				<Impersonate.Panel />
				<Header>
					{updatedReport.name}
					{/*@TODO - temporarily disabled eRecept report. It's too big for live export. */}
					{updatedReport.embedCode === undefined &&
            updatedReport.reportTable !== 'erecept-complete-electronic-prescription' ? (<ExportButton disabled={exportResult.isLoading} exportReport={exportDoc}/>) : null}
				</Header>
			</Container>
			{headerId === header.id && header.id !== '' ? (<ColumnSettings filterColumn={filterColumn} header={header} headerId={headerId} hideColumn={hideColumn} originalReport={updatedReport} removeColumnFilters={removeColumnFilters} removeSort={removeSort} revealColumn={revealColumn} searchParams={searchParams} selectColumn={setHeaderId} sortColumn={sortColumn} onSubmitChanges={function (editedReport) {
                onChange(editedReport);
                setUnusedChanges(true);
            }}/>) : null}
			{updatedReport.embedCode === undefined ? (<Container className='formContainder'>
					<ReportSettings customize={customize} everCustomized={Boolean(customized)} isLoading={isLoading} removeFilter={removeFilter} removeSort={removeSort} revealColumn={revealColumn} savingCustomReport={savedCustomizedReportResult instanceof Loading} unusedChanges={unusedChanges} updatedReport={updatedReport} onSaveCustomReportChanges={saveCustomReportChanges} onSaveReportEdits={function (nextReport) {
                onChange(nextReport);
                setUnusedChanges(true);
            }}/>
				</Container>) : null}

			{updatedReport.description !== undefined || updatedReport.embedCode !== undefined ? (<Container>
					{updatedReport.description}
					{updatedReport.embedCode !== undefined ? <DangerousEmbededHtml html={updatedReport.embedCode}/> : null}
				</Container>) : null}

			{updatedReport.additionalInfo !== null ? (<Container style={{ padding: '0.25rem 0', whiteSpace: 'pre-wrap' }}>{updatedReport.additionalInfo}</Container>) : null}

			{updatedReport.embedCode === undefined ? (<ReportTable custom={updatedReport.isCustom} customized={customized} headers={updatedReport.headers} query={query} reportId={updatedReport.id} reportSettings={updatedReport.reportSettings} selectColumn={setHeaderId} sort={updatedReport.sort.length > 0 ? updatedReport.sort : updatedReport.defaultSort} onChange={updateQuery}/>) : null}
		</div>);
};
